import * as React from 'react';
import { SVGProps } from 'react';

const SvgSearchLocations = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.813 2.875v17.231H9.67v-.789a6.916 6.916 0 0 1-1.065-3.699c0-2.007.851-3.815 2.211-5.084H9.67V8.619h2.286v1.052a6.89 6.89 0 0 1 2.286-.879V8.62h2.286v.116a6.9 6.9 0 0 1 2.286.742V2.877h-16zM5.098 4.79h2.286v1.915H5.098V4.79zm4.572 0h2.286v1.915H9.67V4.79zm4.571 0h2.286v1.915h-2.286V4.79zM5.098 8.619h2.286v1.915H5.098V8.619zm0 3.829h2.286v1.914H5.098v-1.914zm0 3.829h2.286v1.914H5.098v-1.914zM19.43 18.02c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L20.59 22 22 20.59a800.2 800.2 0 0 1-1.044-1.047c-.288-.29-.463-.466-1.526-1.523zM16 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
  </svg>
);

export default SvgSearchLocations;
